// src/ctxReflectorV2/components/Reporting/ReportingData.tsx
import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";

/**
 * Interface for Reporting Server items
 */
export interface ReportingServer {
  id: string;
  serverIp: string;
  port: number;
  description: string;
  associatedCtxrs: number;
  subscription: string;
}

/**
 * Column definitions for the Reporting table
 * Actions column will be overridden in ReportingPage
 */
export const columns: GenericTableColumn<ReportingServer>[] = [
  {
    header: "Server IP",
    accessor: "serverIp",
    sortable: true,
  },
  {
    header: "Port",
    accessor: "port",
    sortable: true,
  },
  {
    header: "Description",
    accessor: "description",
    sortable: true,
  },
  {
    header: (
      <div style={{ 
        position: 'relative',
        width: '100%',
        textAlign: 'center'
      }}>
        <span style={{ 
          display: 'inline-block',
          textAlign: 'center'
        }}>
          Associated <br /> CTX-R&apos;s
        </span>
      </div>
    ),
    accessor: "associatedCtxrs",
    sortable: true,
    renderCell: (row) => (
      <div style={{ 
        width: '100%', 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {row.associatedCtxrs.toString()}
      </div>
    ),
  },
  {
    header: "Actions",
    accessor: "id",
    renderCell: () => <div>Will be overridden in ReportingPage</div>,
  },
];

